import { fromEvent } from 'rxjs';

export const DocumentVisibility = {
  isAppHidden: () => document.hidden,
  fromVisibilityChange: () => fromEvent(document, 'visibilitychange'),
};
